import Job from '~/fc/Converter/job'
import { uuidv4 } from '~/fc/Helpers/FileHelpers'
import { initiateSocketConnection } from '~/fc/socket'

export const preProcessUrlUploadedFile = async (file) => {
    if (!file) return;
    
    try {
        initiateSocketConnection()

        const tasks = generateImportTask(file)    
        const job = new Job(tasks)
        const newJob = await job.processSingleFile({
            file,
            returnJob: true,
            jobId: uuidv4()
        })        

        return newJob
    } catch (err) {
        console.error(err)
    }
};

const generateImportTask = (file) => {
    const tasks = {}
    tasks['import'] = file.gtoken
        ? {
            operation: "import/google-drive",
            fileId: file.url,
            gtoken: file.gtoken,
            filename: file.name,
            filesize: file.size,
        }
        : {
            operation: file.ext === "webpage" ? "import/webpage" : "import/url",
            url: file.url,
            filename: file.name ? file.name : '',
        };

    return tasks
}